import React, { FC, useEffect, useState } from "react";
import { applySentimentColors } from "../../../../core/_helpers";
import { EventWordModel } from "../../../../core/_models";

interface ChapterProps {
  shouldApplySentimentAnalysis: boolean;
  chapterWords: EventWordModel[];
  timerTime: React.MutableRefObject<number>;
  chapterStart: number;
  chapterEnd: number;
  seekedTime: number;
  onWordClick: (time: number) => void;
  highlightTags: boolean;
}

const Chapter: FC<ChapterProps> = ({
  chapterStart,
  chapterEnd,
  chapterWords,
  seekedTime,
  shouldApplySentimentAnalysis,
  timerTime,
  onWordClick,
  highlightTags,
}) => {
  const [words, setWords] = useState<EventWordModel[]>(chapterWords);
  const [playerTime, setPlayerTime] = useState<number>(0);

  useEffect(() => {
    setWords(chapterWords);
  }, [chapterWords]);

  useEffect(() => {
    if (seekedTime !== undefined) {
      if (seekedTime > Number(chapterStart)) {
        setPlayerTime(seekedTime);
        scrollToWord(seekedTime);
      } else {
        setPlayerTime(0);
      }
    }
  }, [seekedTime]);

  useEffect(() => {
    let previousTime = timerTime.current * 1000;

    const intervalId = setInterval(() => {
      if (timerTime.current * 1000 !== previousTime) {
        if (
          timerTime.current * 1000 >= chapterStart &&
          timerTime.current * 1000 <= chapterEnd
        ) {
          setPlayerTime(timerTime.current * 1000);
        }
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  const scrollToWord = (time: number) => {
    const wordToScroll = words.reduce((closestWord, currentWord) => {
      const currentWordDistance = Math.abs(currentWord.start - time);
      const closestWordDistance = Math.abs(closestWord.start - time);

      return currentWordDistance < closestWordDistance
        ? currentWord
        : closestWord;
    }, words[0]);

    if (wordToScroll) {
      var element = document.getElementById(wordToScroll.start.toString());
      var scollableElement = document.getElementById("srollable-transcript");
      if (element) {
        if (element && scollableElement) {
          const containerHeight = scollableElement.clientHeight;
          scollableElement.scrollTop =
            element.offsetTop - containerHeight / 2 - 100;
        }
      }
    }
  };

  const renderWords = () => {
    var wordsCopy = [...words];
    const wordElements = [];

    for (let i = 0; i < wordsCopy.length; i++) {
      const wordElement = createWordElement(wordsCopy[i], i);
      wordElements.push(wordElement);
    }

    return wordElements;
  };

  const createWordElement = (
    word: EventWordModel,
    index: number
  ) => {
    return (
      <span
        key={index}
        className={`${
          word.text == "" ? "hidden" : "highlights-wrapper"
          // {
          //     highlightTags
          //       ? word.tags && word.tags!.length > 0
          //         ? `color-${word.tags![0].color.slice(1)}`
          //         : ""
          //       : ""
          //   }
        }`}
        onClick={() => onWordClick(word.start)}
        data-start={word.start}
        data-end={word.end}
        data-text={word.text}
        data-speaker={word.speaker}
      >
        <>
          <span
            id={word.start.toString()}
            data-start={word.start}
            data-end={word.end}
            className={`event-word ${
              shouldApplySentimentAnalysis ? applySentimentColors(word) : ""
            }`}
            onClick={() => onWordClick(word.start)}
            style={{
              color: playerTime >= word.start ? "var(--bs-primary)" : "",
              paddingRight: "3px",
              borderLeft: "0px",
              borderRight: "0px",
            }}
          >
            {word.text}
          </span>
        </>
      </span>
    );
  };

  return <div className="chapter">{renderWords()}</div>;
};

export default Chapter;
